function formatTimeAgo(date) {
  var now = new Date();
  var diffSec = Math.round((date - now) / 1000);
  var diffMin = Math.round(diffSec / 60);
  var diffHour = Math.round(diffMin / 60);
  var diffDay = Math.round(diffHour / 24);
  var diffMonth = Math.round(diffDay / 30);
  var diffYear = Math.round(diffDay / 365);
  var rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  if (Math.abs(diffSec) < 45) return rtf.format(diffSec, 'second');
  if (Math.abs(diffMin) < 45) return rtf.format(diffMin, 'minute');
  if (Math.abs(diffHour) < 22) return rtf.format(diffHour, 'hour');
  if (Math.abs(diffDay) < 26) return rtf.format(diffDay, 'day');
  if (Math.abs(diffMonth) < 11) return rtf.format(diffMonth, 'month');
  return rtf.format(diffYear, 'year');
}

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('abbr.timeago').forEach(function(el) {
    var date = new Date(el.getAttribute('title'));
    if (!isNaN(date)) {
      el.textContent = formatTimeAgo(date);
    }
  });
});
